const passwordRequiredForLoginSelector = () => true;

export default passwordRequiredForLoginSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/passwordRequiredForLoginSelector.js
 **/